'use client';
import { NotificationContainer } from '@/components/notification-container';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNotifications } from '@/hooks/useNotifications';

export default function Notification() {
  const { getAllNotifications, getInfiniteNotificationsApi } = useNotifications(
    {}
  );
  const allNotifications = getAllNotifications();

  const commentsNotifications = allNotifications.filter(
    (notification) => notification.notificationType === 'COMMENT'
  );
  const mentionsNotifications = allNotifications.filter(
    (notification) => notification.notificationType === 'MENTION'
  );
  const hasNextPage = getInfiniteNotificationsApi.hasNextPage;
  const isFetchingNextPage = getInfiniteNotificationsApi.isFetchingNextPage;

  const isLoading = getInfiniteNotificationsApi.isLoading;

  return (
    <section className="flex flex-col gap-4 p-8 max-w-5xl w-full mx-auto">
      <Card>
        <CardContent className="py-2">
          <Tabs defaultValue="all" className="w-full" variant="underline">
            <TabsList>
              <TabsTrigger value="all">All Notifications</TabsTrigger>
              <TabsTrigger value="comments">Comments</TabsTrigger>
              <TabsTrigger value="mentions">Mentions</TabsTrigger>
            </TabsList>
            <TabsContent value="all">
              <NotificationContainer
                notifications={allNotifications}
                isFetchingNextPage={isFetchingNextPage}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                fetchNextPage={getInfiniteNotificationsApi.fetchNextPage}
              />
            </TabsContent>
            <TabsContent value="comments">
              <NotificationContainer
                notifications={commentsNotifications}
                isFetchingNextPage={isFetchingNextPage}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                fetchNextPage={getInfiniteNotificationsApi.fetchNextPage}
              />
            </TabsContent>
            <TabsContent value="mentions">
              <NotificationContainer
                notifications={mentionsNotifications}
                isFetchingNextPage={isFetchingNextPage}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                fetchNextPage={getInfiniteNotificationsApi.fetchNextPage}
              />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </section>
  );
}
